import { TenantEntity } from '../TenantEntity'
import { isContainClosedCharge } from '@/api/act/closingAccount'

export class ClosingAccount extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'ClosingAccount'
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId || 0
  }
  get inputBy() {
    return this._data.inputBy
  }
  set inputBy(inputBy) {
    this._data.inputBy = inputBy || 0
  }
  get closingDate() {
    return this._data.closingDate
  }
  set closingDate(closingDate) {
    this._data.closingDate = closingDate
  }
  get verifiedBy() {
    return this._data.verifiedBy
  }
  set verifiedBy(verifiedBy) {
    this._data.verifiedBy = verifiedBy || 0
  }
  get verifyDate() {
    return this._data.verifyDate
  }
  set verifyDate(verifyDate) {
    this._data.verifyDate = verifyDate
  }
  get closingAccountType() {
    return this._data.closingAccountType
  }
  set closingAccountType(closingAccountType) {
    this._data.closingAccountType = closingAccountType || 0
  }
  // 判断job里是否存在费用已经关账
  static async isContainClosedCharge(branchId, jobNo) {
    return await isContainClosedCharge({ branchId, jobNo }).then(res => res.data)
  }
}
